var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resource-box',{attrs:{"name":_vm.resourceName}},[_c('div',{staticClass:"warpper",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"echarts",attrs:{"id":"main"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }